// test1621
(1621 && 0);
